import { CanDeactivateFn } from '@angular/router';
import { SettingsPage } from '../pages/settings/settings.page';

export const settingsUnsavedChangesGuard: CanDeactivateFn<SettingsPage> = (component) =>
  component.confirmLeaveWithUnsavedChanges();
